import type {App} from '../../types'
import {flatten, pluck, filter} from 'ramda'
import {mapUniqueCountries} from '../../util/helpers'

const initialState: App = {
  activeTab: 0,
  countryLoader: false,
  accessCountries: {
    search: [],
    monitoring: [],
  },
  infoObj: {
    message: '',
    error: false,
  },
  csUserId: 0,
  languageAccess: [],
  request: {
    url: '',
    type: '',
  },
}

const filterCountries = (country) => country !== undefined

export default (state: App = initialState, action): App => {
  const {type, data, payload} = action

  switch (type) {
    case 'CHANGE_TAB':
      return {
        ...state,
        activeTab: data,
      }
    case 'GET_COUNTRIES':
      return {
        ...state,
        countryLoader: true,
        countryList: [],
        request: {
          ...initialState.request,
        },
      }
    case 'GET_COUNTRIES_SUCCESS':
      return {
        ...state,
        countryLoader: false,
        accessCountries: {
          search: mapUniqueCountries(flatten(pluck('creditsafeConnectOnlineReports', payload.countryAccess))),
          monitoring: mapUniqueCountries(filter(filterCountries, (flatten(pluck('creditsafeConnectMonitoring', payload.countryAccess))))),
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COUNTRIES_FAILURE':
      return {
        ...state,
        countryLoader: false,
        countryList: [],
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_USER_DETAILS':
      return {
        ...state,
      }
    case 'GET_USER_ACCESS':
      return {
        ...state,
      }
    case 'GET_USER_ACCESS_SUCCESS':
      return {
        ...state,
        csUserId: action.csUserId,
        languageAccess: payload.data,
      }
    case 'GET_USER_ACCESS_FAILURE':
      return {
        ...state,
      }
    case 'SEARCH_CRITERIA':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'SEARCH_CRITERIA_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'SEARCH_CRITERIA_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'SEARCH_DATA':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'SEARCH_DATA_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'SEARCH_DATA_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'SET_INFO_OBJ':
      return {
        ...state,
        infoObj: {
          ...data,
        },
      }
    case 'RESET_INFO_OBJ':
      return {
        ...state,
        infoObj: {
          ...initialState.infoObj,
        },
      }
    case 'GET_PORTFOLIOS':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_PORTFOLIOS_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_PORTFOLIOS_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COMPANIES':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_COMPANIES_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COMPANIES_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'CREATE_PORTFOLIO':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'CREATE_PORTFOLIO_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: 'Portfolio created successfully',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'CREATE_PORTFOLIO_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'DELETE_PORTFOLIO':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'DELETE_PORTFOLIO_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: 'Portfolio deleted successfully',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'DELETE_PORTFOLIO_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'REFRESH_TOKEN_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: 'Token refreshed successfully',
        },
      }
    case 'GET_COMPANY_REPORT':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_COMPANY_REPORT_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COMPANY_REPORT_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COMPANY_TREE_LIST':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_COMPANY_TREE_LIST_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_COMPANY_TREE_LIST_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_DECISION_TREE_DATA':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_DECISION_TREE_DATA_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_DECISION_TREE_DATA_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_DECISION_TREE_USER_FIELDS':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_DECISION_TREE_USER_FIELDS_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_DECISION_TREE_USER_FIELDS_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_EVENTS':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'GET_EVENTS_SUCCESS':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'GET_EVENTS_FAILURE':
      return {
        ...state,
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'ADD_COMPANY':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'ADD_COMPANY_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: 'Company added successfully',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'ADD_COMPANY_FAILURE':
      return {
        ...state,
        infoObj: {
          error: true,
          message: payload.data.message || 'Unable to add company to portfolio',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'DELETE_COMPANY':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'DELETE_COMPANY_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: 'Company deleted successfully',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'DELETE_COMPANY_FAILURE':
      return {
        ...state,
        infoObj: {
          error: true,
          message: payload.data.message || 'Unable to delete company from portfolio',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'UPDATE_TRANSLATIONS':
      return {
        ...state,
        request: {
          ...initialState.request,
        },
      }
    case 'UPDATE_TRANSLATIONS_SUCCESS':
      return {
        ...state,
        infoObj: {
          error: false,
          message: payload.message || 'Translation updated successfully',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'UPDATE_TRANSLATIONS_FAILURE':
      return {
        ...state,
        infoObj: {
          error: true,
          message: payload.data.message || 'Unable to update translation',
        },
        request: {
          url: payload.requestUrl,
          type: payload.requestType,
        },
      }
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/app/reducer.js